module.exports = __webpack_public_path__ + "assets/img/12.f06bb291.png";